import { render, staticRenderFns } from "./OptionItem.vue?vue&type=template&id=73ebfc5a&"
import script from "./OptionItem.vue?vue&type=script&lang=js&"
export * from "./OptionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports